import type React from 'react';

interface ExploreIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function ExploreIcon({ size = 24, ...props }: ExploreIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.39062 8C7.39062 7.66992 7.64453 7.39062 8 7.39062C8.33008 7.39062 8.60938 7.66992 8.60938 8C8.60938 8.35547 8.33008 8.60938 8 8.60938C7.64453 8.60938 7.39062 8.35547 7.39062 8ZM10.3359 4.62305C10.9707 4.41992 11.5801 5.0293 11.377 5.66406L10.1328 9.37109C10.0059 9.75195 9.72656 10.0312 9.3457 10.1582L5.63867 11.4023C5.00391 11.6055 4.39453 10.9961 4.59766 10.3613L5.8418 6.6543C5.96875 6.27344 6.24805 5.99414 6.62891 5.86719L10.3359 4.62305ZM10.5898 5.41016L6.88281 6.6543C6.75586 6.67969 6.6543 6.78125 6.62891 6.9082L5.38477 10.6152L9.0918 9.37109C9.21875 9.3457 9.32031 9.24414 9.3457 9.11719L10.5898 5.41016ZM1.5 8C1.5 4.41992 4.39453 1.5 8 1.5C11.5801 1.5 14.5 4.41992 14.5 8C14.5 11.6055 11.5801 14.5 8 14.5C4.39453 14.5 1.5 11.6055 1.5 8ZM8 13.6875C11.123 13.6875 13.6875 11.1484 13.6875 8C13.6875 4.87695 11.123 2.3125 8 2.3125C4.85156 2.3125 2.3125 4.87695 2.3125 8C2.3125 11.1484 4.85156 13.6875 8 13.6875Z"
        fill="currentColor"
      />
    </svg>
  );
}
